<template>
  <div id="new-employee">
    <h4 class="page_heading">Add New Link</h4>
    <div class="row">
      <form @submit.prevent="saveEmployee" class="col s12">
        <div class="row">
          <div class="input-field col s12">
            <md-field>
              <label>LinkO #ID</label>
              <input type="text" v-model="linko_id" required>
            </md-field>
          </div>
        </div>

        <div class="row">
          <div class="input-field col s12">
            <md-field>
              <label>Link #ID</label>
              <input type="text" v-model="link_id" required>
            </md-field>

          </div>
        </div>
        <div class="row">
          <div class="input-field col s12">
            <input type="text" v-model="link_name" required>
            <label>Link Name</label>
          </div>
        </div>
        <div class="row">
          <div class="input-field col s12">
            <input type="text" v-model="link_url" required>
            <label>Link Url</label>
          </div>
        </div>        
        <div class="row">
          <div class="input-field col s12">
            <!--
            <input type="text" v-model="link_type" required>
            <label>Link Type [eg Private, Public, friends]</label>
            -->
            <label>Link Type</label><br>
            <p>
              <label>
                <input class="with-gap" v-model="link_type" value="Public" name="opt_link_type" type="radio" checked />
                <span>Public</span>
              </label>
              <label>
                <input class="with-gap" v-model="link_type" value="Private" name="opt_link_type" type="radio"  />
                <span>Private</span>
              </label></p><p>
              <label>
                <input class="with-gap" v-model="link_type" value="Friends" name="opt_link_type" type="radio"  />
                <span>Friends</span>
              </label>
              <label>
                <input class="with-gap" v-model="link_type" value="Family" name="opt_link_type" type="radio"  />
                <span>Family</span>
              </label>              
            </p>
          </div>
        </div>
        <div class="row">
          <div class="input-field col s12">
            <textarea v-model="link_desc" required> </textarea>
            <label>Link description</label>
            
          </div>
        </div>  

        <div class="row">
          <div class="input-field col s12">
            <!---
            <input type="text" v-model="link_category" required>
            <label>Link Category [ Docs, Code etc]</label>
            --->
            <select v-model="link_category" >
              <option value="" disabled selected>[Select Option]</option>
              <option v-for="(item,key) in link_cat_list" :value="item" :key="key">{{item}}</option>
            </select>
            <label>Link Category {{link_category}} </label>
          </div>
        </div>

        <router-link to="/" class="btn grey">Back</router-link>

        <button type="submit" @submit.prevent="saveEmployee" class="btn green">Submit</button>
      </form>
      
    </div>
    
  </div>
</template>

<script>
import db from "./firebaseInit";


export default {

  name: "new-employee",
  data() {
    return {
      linko_id : null,
      link_id: null,
      link_name: null,
      link_url: null,
      link_type: null,
      link_desc: null,
      link_category: null,

      link_cat_list : [
        "Web links",
        "App Links",
        "Personal Documents",
        "Official Documents",
        "Online Shopping",
        "Other"
      ]
    };
  },
  methods: {
    saveEmployee() {
      //console.log(this.linko_id);

      db.collection("linkinfo")
        .add({
          linko_id: this.linko_id,  //userid or linkoid
          link_id: this.link_id,
          link_name: this.link_name,
          link_url: this.link_url,
          link_type: this.link_type,
          link_desc: this.link_desc,
          link_category: this.link_category
        })
        .then(docRef => this.$router.push("/"))
        .catch(err => console.log(err));
    }
  },
  mounted:function(){
    //Initialize select (dropdown box)
    $('select').formSelect();
    //$('select').append("<option>sfsfd</option>");

    //read th value of linko_id from central store.js
    this.linko_id = this.$store.state.linko_id;
  },

  /* 
  computed:{
    get_linko_id:function(){
      this.linko_id = this.$store.state.linko_id;
      return this.linko_id;
    }
  }
  */
};



</script>

<style>
textarea{
  padding:10px;
  height:100px;
  border-left: 0px;
  border-right: 0px;
  
}
div > label{
  padding-left: 10px;
  font-weight: 600;
  font-size: 14px !important;
}
.dropdown-content
{
  height:350px !important;
}

</style>




// WEBPACK FOOTER //
// src/components/LinkAddNew.vue